import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./ReuseableComponent.css";

import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky";

const GCModalV1 = ({
  xOpen = false,
  fCloseModal,
  xTitle = "",
  component,
  height = " 400px",
  width = " 400px",
  xsheight = " 400px",
  xswidth = " 95%",
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  return (
    <Modal
      open={xOpen}
      onClose={fCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          flexGrow: 1,
          overflow: "auto",
          position: "absolute !important",
          top: " 50%",
          left: " 50%",
          transform: " translate(-50%, -50%)",
          width: vMediaQuery ? xswidth : width,
          height: vMediaQuery ? xsheight : height,
          backgroundColor: " var(--commonText)",
          border: " 1px solid var(--primary)",
          boxShadow: " 24",
          borderRadius: " 10px",
        
        }}
        // className="

        // model-pklst"
      >
        <GCTitleSticky title={xTitle} onClose={fCloseModal} />

        <div className="p-4">{component}</div>
      </Box>
    </Modal>
  );
};

export default GCModalV1;
